module.exports = __webpack_public_path__ + "img/7.858d0dbb.jpg";